import { Component, OnInit, Pipe, PipeTransform, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { RestService } from '../../../shared/shared.module';

@Pipe({ name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
@Component({
  selector: 'app-confidential',
  templateUrl: './confidential.component.html',
  styleUrls: ['./confidential.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ConfidentialComponent implements OnInit {

  public myTemplate: any = '';
  constructor(private restService: RestService) {
    this.restService.urlGet<string>('/assets/Documents/confidential.html', { responseType: 'text' })
      .then(data =>
        this.myTemplate = data
      );
  }


  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landing/info/confidential/confidential.component.ts